module.exports = __webpack_public_path__ + "images/65c09c15eeec4baa0df09774ee403f21.jpg";